import { FC } from "react"

import { useTranslation } from "react-i18next"

import { CurrencyFiatLimit } from "services/settings/type"

import { NumberField } from "../inputs/NumberField"

interface LimitsDepositFieldsProps {
  idPrefix: string
  // Path to the deposit object inside the limits tree, e.g. ["deposit", "fiat"] or ["currencyLimits", "BRL", "deposit"].
  basePath: string[]
  values: CurrencyFiatLimit["deposit"]
  // Already-translated noun for the label, e.g. "Fiat Deposit" / "Crypto Deposit" / "Deposit".
  typeLabel: string
  currencyCode?: string
  onUpdate: (path: string[], value: string) => void
  disabled?: boolean
}

// Min/Max grid for the FTD (first-time) and STD (returning) deposit thresholds.
export const LimitsDepositFields: FC<LimitsDepositFieldsProps> = ({
  idPrefix,
  basePath,
  values,
  typeLabel,
  currencyCode,
  onUpdate,
  disabled
}) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  const fields = [
    { key: "ftd-min", bound: "min", phase: "FTD", value: values.ftd.min, path: ["ftd", "min"] },
    { key: "ftd-max", bound: "max", phase: "FTD", value: values.ftd.max, path: ["ftd", "max"] },
    { key: "std-min", bound: "min", phase: "STD", value: values.std.min, path: ["std", "min"] },
    { key: "std-max", bound: "max", phase: "STD", value: values.std.max, path: ["std", "max"] }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
      {fields.map((field) => (
        <NumberField
          key={field.key}
          id={`${idPrefix}-${field.key}`}
          label={t("settings.limits.depositFieldLabel", {
            bound: t(`settings.limits.${field.bound}`),
            type: typeLabel,
            phase: field.phase
          })}
          value={field.value}
          onChange={(v) => onUpdate([...basePath, ...field.path], v)}
          centsDisplay
          currencyCode={currencyCode}
          disabled={disabled}
        />
      ))}
    </div>
  )
}
